// components/ScrollToSectionButton.jsx
import React, { useState, useEffect } from "react";
import { Fab, Tooltip, Zoom, IconButton } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  WhatsApp,
 
} from '@mui/icons-material';

export default function ScrollToSectionButton({
  targetId = null, // null means scroll to top
  tooltip = "",
  showAfter = 200,
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScrollVisibility = () => {
      setVisible(window.scrollY > showAfter);
    };
    window.addEventListener("scroll", handleScrollVisibility);
    return () => window.removeEventListener("scroll", handleScrollVisibility);
  }, [showAfter]);

  const handleScroll = () => {
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    } else {
      // No targetId → scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    // <Zoom in={visible}>
    //   <Tooltip
    //     title={tooltip || (targetId ? `Scroll to ${targetId}` : "Scroll to top")}
    //     placement="left"
    //   >
    //     <Fab
    //       aria-label="scroll"
    //       onClick={handleScroll}
    //       sx={{
    //         position: "fixed",
    //         bottom: { xs: 10, sm: 15 },
    //         right: { xs: 20, sm: 30 },
    //         zIndex: 1200,
    //         width: 56,
    //         height: 56,
    //         background: "#388e3c", // Green color
    //         boxShadow: 4,
    //         "&:hover": { background: "#388e3c" }, // Darker green on hover
    //       }}
    //     >
    //       <KeyboardArrowUpIcon sx={{ fontSize: 32, color: "#fff" }} />
    //     </Fab>
    //   </Tooltip>
    // </Zoom>

    <Zoom in={visible} timeout={2000}>
                  <IconButton
                    sx={{
                      position: 'fixed',
                      bottom: 30,
                      right: 30,
                      bgcolor: '#25D366',
                      color: 'white',
                      width: 65,
                      height: 65,
                      boxShadow: '0 8px 20px rgba(37, 211, 102, 0.4)',
                      '&:hover': {
                        bgcolor: '#128C7E',
                        transform: 'scale(1.1)',
                      },
                      transition: 'all 0.3s',
                      zIndex: 1000
                    }}
                    href="https://wa.me/918005968738?text=Hello%20BizBridge%20Team%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
                    target="_blank"
                  >
                    <WhatsApp sx={{ fontSize: 35 }} />
                  </IconButton>
                </Zoom>

    
  );
}
